module.exports = __webpack_public_path__ + "static/media/Encil_03.ea571634.pdf";